module.exports = __webpack_public_path__ + "static/2-0e3acc30cb85404077546c1fc6284bbb.jpg";